import React from "react"
import Head from "next/head"
import { NextPage } from "next"
import { DefaultLayout } from "src/components/Layout"
import { CreditContractPreparationList } from "src/features/credit-contract-preparation-list/components/CreditContractPreparationList"
import { CreditContractPreparationStatus } from "src/features/credit-contract-preparation-list/types"

// デフォルトフィルタステータスの設定
const DEFAULT_FILTER_STATUSES: CreditContractPreparationStatus[] = ["action_required"]

const CreditContractPreparationListPage: NextPage = () => {
  return (
    <DefaultLayout>
      <Head>
        <title>クレジット契約準備一覧 | for CS</title>
      </Head>

      <div className="min-h-screen bg-gray-50">
        <div className="mx-auto max-w-11/12 px-4 py-6 sm:px-6 lg:px-8">
          {/* ページヘッダー */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">クレジット契約準備一覧</h1>
          </div>

          {/* メインコンテンツ */}
          <CreditContractPreparationList defaultStatuses={DEFAULT_FILTER_STATUSES} />
        </div>
      </div>
    </DefaultLayout>
  )
}

export default CreditContractPreparationListPage
